import { useMemo } from 'react';

import { paths } from 'src/routes/paths';

import SvgColor from 'src/components/svg-color';
import Iconify from 'src/components/iconify/iconify';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  home: icon('ic_home'),
  learn: icon('ic_learn'),
  message: icon('ic_message'),
  result: icon('ic_result'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  const data = useMemo(
    () => [
      {
        groupRoles: ['Student', 'Teacher'],
        items: [
          {
            title: '홈',
            path: paths.dashboard.root,
            icon: ICONS.home,
          },
        ],
      },
      {
        groupRoles: ['Admin'],
        items: [
          {
            title: '문제 DB',
            path: '/questiondb',
            icon: <Iconify icon="lucide:file-question" width={24} />,
            children: [
              { title: '문제 목록', path: paths.questiondb.list },
              { title: '문제 생성', path: paths.questiondb.new },
              { title: '문제 오류 신고', path: paths.questiondb.report },
            ],
          },
        ],
      },
      {
        groupRoles: ['Admin'],
        items: [
          {
            title: '개인결제',
            path: '/inquiry',
            icon: <Iconify icon="ic:baseline-contact-support" width={24} />,
            children: [{ title: '개인결제 관리', path: paths.inquiry.list }],
          },
        ],
      },
      {
        groupRoles: ['Admin'],
        items: [
          {
            title: '문제생성기',
            path: '/qgen',
            icon: <Iconify icon="ic:baseline-contact-support" width={24} />,
            children: [
              { title: '문제생성', path: paths.qgen.new },
              { title: '데이터 관리', path: paths.qgen.list },
            ],
          },
        ],
      },
      {
        groupRoles: ['Admin'],
        items: [
          {
            title: '워크북',
            path: '/workbook',
            icon: <Iconify icon="ic:baseline-contact-support" width={24} />,
            children: [
              { title: '목록', path: paths.workbook.list },
              { title: '생성', path: paths.workbook.new },
            ],
          },
        ],
      },
      {
        groupRoles: ['Teacher'],
        items: [
          {
            title: '유저 DB',
            path: '/userdb',
            icon: <Iconify icon="ph:users-three-bold" width={24} />,
            children: [{ title: '유저 목록', path: paths.userdb.list }],
          },
        ],
      },
    ],
    []
  );

  return data;
}
